import { useState, useEffect, useCallback } from "react";
import { JsonRpcProvider, ethers } from "ethers";
import { useProviderResult } from "../Components/interface";

export const useDexProvider = (): useProviderResult => {
  const [provider, setProvider] = useState<JsonRpcProvider | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const mainProvider = new ethers.JsonRpcProvider(
      "https://mainnet.infura.io/v3/50e5d235b7514fc187a574e49ebff028",
    );
    const backupProvider = new ethers.JsonRpcProvider(
      "https://eth-mainnet.g.alchemy.com/v2/_smQ78gEL1QZYov9FwnXjSOq8pR3f6N8",
    );

    const fetchProvider = async () => {
      try {
        setIsLoading(true);
        setProvider(mainProvider);
      } catch (mainError) {
        console.warn("Main provider failed:", mainError);
        try {
          await backupProvider.getBlockNumber(); // 尝试使用备用 provider
          setProvider(backupProvider);
        } catch (backupError) {
          console.error("Backup provider also failed:", backupError);
          setError("All providers failed to connect.");
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchProvider();
  }, []);

  return { provider, error, isLoading };
};
